<template>
  <div class="l_basic_setting_faq">
    <div class="container">
      <div class="content">
      <p>・削除したアカウントの履歴の復帰はできません。</p>
      <p>・アプリIDに連携していたAppleIDアカウントは削除と同時に解除されます。削除後、連携していたAppleIDアカウントでのログインはできません。</p>
      <p>・香の川製麺商品レシート・領収書応募サービスにアプリIDで連携していた場合、香の川製麺商品レシート・領収書応募サービスでの履歴及び取得した特典などにアクセスできなくなります。</p>
      <p>・削除後にお問い合わせを頂いても、調査はできません。あらかじめご了承ください。</p>
         <div class="l_button__external">
          <UIButton :label="'アプリアカウントを削除'" @click="link()" />
        </div>
      </div>
    </div>
     <!-- アラート表示 -->
    <template v-if="this.isUseAlert">
      <alert-accountdelete
        @sendDelete="tapSend"
        @close="tapAlertAccountDeleteClose"
      />
    </template>
    <!-- エラーパネル -->
    <template v-if="this.isError">
      <error-popup
        :title="this.errorTitle"
        :message="this.errorMessage"
        :label="'エラー'"
        @close="() => tapErrorClose()"
      />
    </template>
    <template v-if="this.showSIWAAlert">
      <alert
        title=""
        message="AppleID連携済みの場合は、アプリアカウントとAppleIDの連携を解除するために、アプリアカウントの削除前にもう一度AppleIDでのサインインが必要になります"
        label="OK"
        @close="() => tapSIWAAlertClose()"
      />
    </template>
     <VersionCheck
      :show="verAlert"
      :on-close="closeAlert"
      :msg="versionErrorMsg"
    />
 </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UIButton from '@/components/UIButton'
import AlertAccountdelete from '../components/Modal/AlertAccountdelete'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import DateFormatter from '../utils/DateFormatter.js'
import { FactoryTrack } from '../constant/firebase.js'
import VersionCheck from './FAQWalkVersionCheck'
import APIClient, { ErrorCode } from '@/api/APIClient'
import Alert from '@/components/Modal/Alert'

export default {
  name: 'FAQAccountDelete',
  components: {
    Alert,
    UIButton,
    AlertAccountdelete,
    ErrorPopup,
    VersionCheck
  },
  data: function() {
    return {
      isUseAlert: false,
      isError: false,
      errorMessage: '',
      errorTitle: '',
      progress: 0,
      loaded: false,
      AccountDeleteComplete: false,
      verAlert: 0,
      versionErrorMsg: '',
      linkedSIWA: false,
      showSIWAAlert: false
    }
  },
  created() {
    document.title = 'アプリアカウント削除'
    try {
      window.receivedToken = async (payload, apiType) => {
        const json = JSON.parse(payload)
        const ver60 = await this.actionVer6_0()
        if (apiType === 3 || json.apiType === '3') {
          this.fetchAccountDelete(json.app_token, json.acc_time, json.user_id)
        } else if (apiType === 12 && ver60 === 0) {
          this.fetchUserSIWA(json)
        }
      }
    } catch (e) {
      console.log(e)
    }
    this.receivedAccountDeleteComplete()

    try {
      this.actionRequestToken({ apiType: '12', acc_time: new DateFormatter().format(new Date()) })
    } catch (e) {
      console.log(e)
    }

    try {
      window.receivedSIWAIdTokenAuthCode = async payload => {
        const json = JSON.parse(payload)

        this.actionToggleLoading(true)
        await APIClient.postRevokeSIWAToken(json.app_token, json.acc_time, json.user_id, json.id_token, json.nonce, json.auth_code)
        this.actionToggleLoading(false)

        this.executeDelete()
      }
    } catch (e) {
      console.log(e)
    }
 },
  mounted: function() {},
  beforeDestroy() {},
  computed: {
    ...mapGetters({
      user_data: 'AccountDelete/user_data',
      histories: 'LoginBonus/histories',
      girl: 'LoginBonus/girl'
    })
  },
  watch: {},
  methods: {
    ...mapActions('Native', ['actionNavigateTo', 'actionVer5_3', 'actionVer6_0']),
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Modal', ['action_ToggleModal']),
    ...mapActions('Native', ['actionRequestToken', 'actionSendAppAccountDelete', 'actionRequestSIWAWithAuthCode']),
    ...mapActions('AccountDelete', ['actionFetchAccountDelete']),
    goBack: function() {
      this.$router.push({ name: 'FAQ' })
    },
    async link() {
      this.verAlert = await this.actionVer5_3()
      this.versionErrorMsg =
        'このボタンはアプリバージョン5.3.0以上対応です。<br />最新版のアプリにアップデートしてください。'
      if (this.verAlert === 0) {
        this.showAccountDelete()
      }
      return false
    },
    closeAlert: function() {
      this.trackEvent(FactoryTrack.createVersionCheckClose())
      this.verAlert = 0
    },
    showAccountDelete() {
      this.trackEvent(FactoryTrack.createAccountDeleteAlertOpen())
      this.action_ToggleModal(true)
      this.isUseAlert = true
    },
    async tapSend() {
      if (this.linkedSIWA) {
        this.isUseAlert = false
        this.showSIWAAlert = true
      } else {
       this.executeDelete()
      }
    },
    executeDelete() {
      this.trackEvent(FactoryTrack.createSendAccountDelete())
      this.action_ToggleModal(false)
      this.isUseAlert = false
      const accTime = new DateFormatter().format(new Date())
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
    },
    tapAlertAccountDeleteClose() {
      this.trackEvent(FactoryTrack.createAccountDeleteAlertClose())
      this.action_ToggleModal(false)
      this.isUseAlert = false
    },
    async fetchAccountDelete(token, accTime, userId) {
     try {
      this.actionToggleLoading(true)
      await this.actionFetchAccountDelete({
        token,
        accTime,
        userId
      })
      this.actionToggleLoading(false)
      this.sendAccountDelete()
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.isError = true
        console.error(e)
      }
      this.actionToggleLoading(false)
    },
    async sendAccountDelete() {
      this.trackEvent(FactoryTrack.createSendAccountDelete())
      this.actionSendAppAccountDelete()
    },
    tapErrorClose() {
      this.trackEvent(FactoryTrack.createErrorClose())
    },
    receivedAccountDeleteComplete() {
      try {
        window.receivedAccountDeleteComplete = payload => {
          this.AccountDeleteComplete = payload === 'true'
          console.log('receivedAccountDeleteComplete')
          this.$router.push({ name: 'AccountDelete' })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async fetchUserSIWA(payload) {
      const token = payload.app_token
      const userId = payload.user_id
      const accTime = payload.acc_time

      this.actionToggleLoading(true)

      const res = await APIClient.postFetchUserSIWA(token, accTime, userId)
      if (res.status === 200 && res.data.data.code === ErrorCode.CODE_SUCCESS && res.data.data.user_id.length > 0) {
        // TODO: Apple のポリシー変更に従い、アカウント削除時に SIWA の token を revoke する対応を行った
        // SIWA 時に token を発行していないため、 Apple のポリシー変更に無理やり対応するため、アカウント削除時に再度 SIWA を行い token を発行していた
        // 上記の処理は完全にオーバーヘッド
        // 2022-11-11 の AppStoreConnect 提出時点では、この処理を行わなくても審査通過
        // Apple からの指摘があるまでは無駄な処理を行わない
        // this.linkedSIWA = true
      }

      this.actionToggleLoading(false)
    },
    tapSIWAAlertClose() {
      this.actionRequestSIWAWithAuthCode()
    }
  }
}
</script>

<style lang="scss"  scoped>
.l_basic_setting_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
}

.l_basic_setting_faq h3,
.l_basic_setting_faq h4 {
  color: #602209;
}

.l_basic_setting_faq .l_button__external {
  width: 250px;
  margin: 20px auto 0;
}
.l_basic_setting_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
}
.l_basic_setting_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid #efb90f;
}
.l_basic_setting_faq .content img {
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}

.caption {
  text-align: left;
  width: 100%;

  &.right {
    text-align: right;
  }

  font-size: 3vw;
  color: rgb(102, 102, 102);
}
</style>
